import {TourSteps} from './interface/tour-steps.interface';
import Step from 'shepherd.js/src/types/step';

export const adviceStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({steps, buttons, services, cb}: TourSteps): Step.StepOptions[] => {
    const nextButton: Step.StepOptions = {
      ...steps.default,
      id: 'advice10',
      title: 'Siguiente paso',
      text: 'Presiona el botón para avanzar al siguiente paso.',
      attachTo: {
        element: '.shepherd-patient-information-btn-next',    // @ts-ignore
        on: 'top',
      },
      advanceOn: {
        selector: '.shepherd-patient-information-btn-next',
        event: 'click'
      },
      buttons: [{...buttons.cancel}],
      beforeShowPromise: () => {
        return new Promise((resolve): void => {
          services.utilitiesService.scrollToElement('.shepherd-patient-information-btn-next', { behavior: 'auto', block: 'center', inline: 'center' });
          resolve(true);
        });
      }
    };

    return [
      {
        ...steps.default,
        id: 'advice20',
        title: 'Asesoría',
        text: 'Cuando se ingresa a la asesorías automáticamente se mostrará un indicador contabilizando el tiempo de la cita. Al concluir el tiempo de la cita, el sistema cambiará el estatus a completado o bien lo puedes hacer de forma manual dando clic sobre el botón "Finalizar".',
        attachTo: {
          element: 'app-date-indicator',
          on: 'bottom',
        },
        canClickTarget: false,
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.existElementInDom().byId('app-date-indicator').subscribe({
              complete: () => {
                resolve(true);
              }
            });
          });
        },
      },
      {
        ...steps.default,
        id: 'advice10',
        title: 'Pasos',
        text: 'Aquí podrás visualizar los pasos para completar la asesoría con un paciente. También podrás cambiar entre ellos.',
        attachTo: {
          element: '.shepherd-steps',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
      },
      // Patient information
      {
        ...steps.default,
        id: 'advice11',
        title: 'Información',
        text: 'En este paso muestra información básica del paciente.',
        attachTo: {
          element: '.shepherd-step-1',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice12',
        title: 'Editar información',
        text: 'Presiona el siguiente botón para editar la información del paciente.',
        attachTo: {
          element: '.shepherd-btn-edit-information',    // @ts-ignore
          on: 'top',
        },
        advanceOn: {
          selector: '.shepherd-btn-edit-information',
          event: 'click',
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        id: 'advice13',
        title: 'Editar información',
        text: 'Aquí podrás actualizar los datos básicos del paciente. Para fines del tour, seguiremos sin editar la información.',
        attachTo: {
          element: '.shepherd-patient-information-form',    // @ts-ignore

          on: 'top',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice14',
        title: 'Guardar información',
        text: 'Presiona el botón para guardar los cambios.',
        attachTo: {
          element: '.shepherd-patient-information-btn-save',    // @ts-ignore

          on: 'top',
        },
        advanceOn: {
          selector: '.shepherd-patient-information-btn-save',
          event: 'click',
        },
        buttons: [{...buttons.cancel}],
      },
      {...nextButton},
      // Fichas
      {
        ...steps.default,
        id: 'advice20',
        title: 'Fichas',
        text: 'Este paso muestra las fichas relacionadas al paciente.',
        attachTo: {
          element: '.shepherd-step-2',    // @ts-ignore

          on: 'bottom',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice21',
        title: 'Paso anterior',
        text: 'Si deseas regresar al paso anterior, lo podrás realizar mediante este botón.',
        attachTo: {
          element: '.shepherd-patient-information-btn-back',    // @ts-ignore

          on: 'top',
        },
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Entendido',
          },
          {...buttons.cancel},
        ],
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice22',
        title: 'Fichas del paciente',
        text: 'La plataforma Dèliè ofrece una gran variedad de fichas para llevar una evaluación más exacta del paciente. Aquí podrás capturar los datos que consideres para la asesoría.',
        attachTo: {
          element: 'app-consultation-file',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice23',
        title: 'Hábitos generales',
        text: 'En esta ficha podremos visualizar y editar los hábitos del paciente. Da clic sobre la ficha para continuar.',
        attachTo: {
          element: '.shepherd-file-0',    // @ts-ignore
          on: 'top',
        },
        advanceOn: {
          selector: '.shepherd-file-0',
          event: 'click',
        },
        buttons: [{...buttons.cancel}],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.existElementInDom().byClassName('shepherd-file-0').subscribe({
              complete: () => resolve(true)
            });
          });
        },
      },
      {
        ...steps.default,
        id: 'advice24',
        title: 'Hábitos generales',
        text: 'La ficha registra los hábitos del paciente tales como: Ingesta de alcohol o café, si es fumador, entre otros.',
        attachTo: {
          element: '.record-history-habits',
          on: 'top',
        },
        canClickTarget: false,
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.existElementInDom().byClassName('record-history-habits').subscribe({
              complete: () => resolve(true)
            });
          });
        },
      },
      {
        ...steps.default,
        id: 'advice25',
        title: 'Guardar hábitos generales',
        text: 'Es importante guardar cambios, para que estos se puedan ver reflejados.',
        attachTo: {
          element: 'app-record-history-habits button',    // @ts-ignore
          on: 'top',
        },
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Entendido',
          },
          {
            ...buttons.cancel,
          }
        ],
      },
      {
        ...steps.default,
        id: 'advice26',
        title: 'Fichas del paciente',
        text: 'Puedes regresar al listado de fichas presionando sobre este botón.',
        attachTo: {
          element: 'app-consultation-file .shepherd-consultation-file-btn-back',    // @ts-ignore
          on: 'top',
        },
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Entendido',
          },
          {...buttons.cancel},
        ],
        canClickTarget: false,
      },
      {...nextButton},
      // Mediciones
      {
        ...steps.default,
        id: 'advice30',
        title: 'Mediciones',
        text: 'Este paso muestra las mediciones registradas del paciente.',
        attachTo: {
          element: '.shepherd-step-3',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice31',
        title: 'Plantillas de mediciones',
        text: 'Las plantillas se configuran en el módulo "Mi perfil", las cuales nos permiten agrupar medidas y asignarlas a los pacientes de acuerdo a sus necesidades.',
        attachTo: {
          element: 'app-consultation-measurement .shepherd-templates',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice32',
        title: 'Medidas',
        text: 'Aquí podremos visualizar y agregar mediciones al paciente. Para fines del tour, el paciente cuenta con algunas mediciones.',
        attachTo: {
          element: 'app-consultation-measurement app-new-measurement',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
      },
      {...nextButton},

      // Formulas
      {
        ...steps.default,
        id: 'advice33',
        title: 'Formulas',
        text: 'Este paso muestra las fórmulas que el sistema ha considerado para el paciente.',
        attachTo: {
          element: '.shepherd-step-4',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice34',
        title: 'Mediciones agregadas',
        text: 'Esta sección mostrará las nuevas medicines que se hayan agregado en el paso anterior. Para fines del tour, no contamos con datos en esta sección.',
        attachTo: {
          element: 'app-consultation-formulas .shepherd-measurements',    // @ts-ignore
          on: 'top',
        },
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Entendido',
          },
          {...buttons.cancel}
        ],
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice36',
        title: 'Formula',
        text: 'Aquí podemos observar una fórmula que el sistema ha sugerido para el paciente, en cada una de las fórmulas podremos visualizar que mediciones faltan para que la plataforma Délié pueda hacer el cálculo.',
        attachTo: {
          element: 'app-consultation-formulas app-basic-formulas .shepherd-formula-autogenerate-imc_adult',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice37',
        title: 'Guardar medida',
        text: 'Presiona el siguiente botón para guardar los resultados de las formulas generadas por el sistema. Recuerda que es importante guardar para que los cambios se vean reflejados en el sistema.',
        attachTo: {
          element: 'app-consultation-formulas app-basic-formulas button',    // @ts-ignore
          on: 'top',
        },
        advanceOn: {
          selector: 'app-consultation-formulas app-basic-formulas button',
          event: 'click',
        },
        buttons: [{...buttons.cancel}],
      },
      {...nextButton},
      // Diagnostico
      {
        ...steps.default,
        id: 'advice40',
        title: 'Diagnostico',
        text: 'Este paso muestra la clasificación del paciente generada por el sistema.',
        attachTo: {
          element: '.shepherd-step-5',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice41',
        title: 'Diagnostico',
        text: 'La plataforma Dèliè ha clasificado al paciente como "CUERPO GINOIDE", grado 1 y riesgo cardiovascular alto. Además podemos observar una tabla que nos indica los diferentes grados del riesgo cardiovascular.',
        attachTo: {
          element: 'app-complex-formulas',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
      },
      {...nextButton},
      // MealPlans
      {
        ...steps.default,
        id: 'advice50',
        title: 'Orientación alimenticia',
        text: 'En este paso puedes crear o seleccionar un plan de alimentación para asignarlo al paciente.',
        attachTo: {
          element: '.shepherd-step-6',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice51',
        title: 'Nuevo plan de alimentación',
        text: 'En esta sección podrás crear un plan de alimentación completamente nuevo y asignarlo al paciente.',
        attachTo: {
          element: '.shepherd-new-meal-plan',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
        buttons: [
          {
            text: 'Crear plan',
            classes: 'shepherd-button shepherd-button-secondary',
            // tslint:disable-next-line:typedef
            action(): void {
              cb('createPlan');
            }
          },
          ...steps.default.buttons,
        ]
      },
      {
        ...steps.default,
        id: 'advice52',
        title: 'Seleccionar plan de alimentación',
        text: 'En esta sección podrás escoger entre los planes de alimentación que tiene registrados tu clínica.',
        attachTo: {
          element: '.shepherd-select-meal-plan',    // @ts-ignore
          on: 'top',
        },
        buttons: [
          {
            text: 'Seleccionar plan',
            classes: 'shepherd-button shepherd-button-secondary',
            // tslint:disable-next-line:typedef
            action(): void {
              cb('selectPlan');
            }
          },
          ...steps.default.buttons,
        ],
        canClickTarget: false,
      },

      {...nextButton},
      {
        ...steps.default,
        id: 'advice52',
        title: 'Descargar PDF',
        text: 'En esta sección podrás descargar un PDF con información relevante del paciente.',
        attachTo: {
          element: '.section-download-patient-template',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.existElementInDom().byClassName('section-download-patient-template').subscribe({
              complete: () => resolve(true)
            });
          });
        },
      },
      {
        ...steps.default,
        id: 'advice52',
        title: 'Descargar PDF',
        text: 'Para descargar el PDF da clic en el botón.',
        attachTo: {
          element: '.download-patient-template',    // @ts-ignore

          on: 'top',
        },
        advanceOn: {
          selector: '.download-patient-template',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      },

      // Finish
      {
        ...steps.default,
        id: 'advice60',
        title: 'Asesoría',
        text: '¡Muy bien!. Has finalizado el tour de "Asesoría".',
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              cb('tourFinished');
            },
            text: 'Entendido'
          },
        ]
      },
    ];
  };
